<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path style="stroke:  var(--{{variableName}});" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 1 1-17.999 0A9 9 0 0 1 21 12z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

